/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type CreateRelatedClientBodyAgeCategoryType =
  (typeof CreateRelatedClientBodyAgeCategoryType)[keyof typeof CreateRelatedClientBodyAgeCategoryType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateRelatedClientBodyAgeCategoryType = {
  adult: "adult",
  child: "child",
  plannedChild: "plannedChild",
} as const;
